module.exports = __webpack_public_path__ + "static/media/Imagen_9.48f48b88.jpg";